import React from "react";
import {
  formatAdminTableDate,
  type AdminTableDateOptions,
} from "../../../lib/formatAdminTableDate";
import { AdminDeleteForm } from "./AdminDeleteForm";
import type { AdminQuote, AdminRouteMap } from "../types";

type AdminQuotesTableProps = {
  quotes: AdminQuote[];
  dateOptions: AdminTableDateOptions;
  csrfToken: string;
  adminRoutes: AdminRouteMap;
  showBusinessColumn?: boolean;
};

export const AdminQuotesTable: React.FC<AdminQuotesTableProps> = ({
  quotes,
  dateOptions,
  csrfToken,
  adminRoutes,
  showBusinessColumn = true,
}) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-border">
          {showBusinessColumn && (
            <th className="text-left py-3 px-4 font-medium">Business</th>
          )}
          <th className="text-left py-3 px-4 font-medium">Customer</th>
          <th className="text-left py-3 px-4 font-medium">Service</th>
          <th className="text-left py-3 px-4 font-medium">Status</th>
          <th className="text-left py-3 px-4 font-medium">Created</th>
          <th className="text-left py-3 px-4 font-medium w-28">Actions</th>
        </tr>
      </thead>
      <tbody>
        {quotes.map((q) => (
          <tr key={q.id} className="border-b border-border last:border-0">
            {showBusinessColumn && (
              <td className="py-3 px-4 font-medium">{q.businessSubdomain}</td>
            )}
            <td className="py-3 px-4">
              {q.name}{" "}
              <span className="text-muted-foreground">({q.email})</span>
            </td>
            <td className="py-3 px-4">{q.service}</td>
            <td className="py-3 px-4 capitalize">{q.status}</td>
            <td className="py-3 px-4 text-muted-foreground">
              {formatAdminTableDate(q.createdAt, dateOptions)}
            </td>
            <td className="py-3 px-4">
              <AdminDeleteForm
                action={adminRoutes.adminDestroyQuote.replace(
                  ":id",
                  String(q.id),
                )}
                csrfToken={csrfToken}
                confirmMessage={`Delete quote from ${q.name} (${q.email})?`}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
